import ProductCardMediaEnum from './ProductCardMediaEnum.js';

enum ListGalleryCardMediaEnum {
	singleImage = ProductCardMediaEnum.singleImage,
	switchImageOnHover = ProductCardMediaEnum.switchImageOnHover
}
export default ListGalleryCardMediaEnum;
